import * as React from 'react';
import classnames from 'classnames';

const styles = require('./IconFavorite.scss');

interface Props {
    onClick: () => void;
    hideText?: boolean;

    isFavorite: boolean;
    isUpdating: boolean;
}

export default class Favorite extends React.Component<Props> {
    public render() {
        return (
            <div className={styles.className} onClick={this.props.onClick}>
                <div className={styles.inner}>
                    <span className={styles.iconAnimationWrapper}>
                        <span
                            className={classnames(styles.icon, 'icon-hb-nx-heart-filled', {
                                [styles.active]: this.props.isFavorite,
                                [styles.animating]: this.props.isUpdating,
                                [styles.iconFilled]: this.props.isFavorite,
                            })}
                        />
                    </span>
                    {!this.props.hideText && <span className={styles.text}>FAVORITE</span>}
                </div>
            </div>
        );
    }
}
